import _map from 'lodash/map';
import _get from 'lodash/get';
import { errorHandler } from 'common/utils/notifications';
import { capitalizeFirst } from '@/common/utils/texts';

export const humanizeErrorMessage = message => {
  const errorMessageCapitalized = message ? capitalizeFirst(message) : null;
  const parseMessage = errorMessageCapitalized?.split('_')?.join(' ') || '';

  return parseMessage;
};

export const getErrorMessage = error => {
  if (error?.status === 403 || error?.response?.status === 403) {
    return '';
  } else if (error && error.status && error.status === 422 && error.data.data) {
    return error?.data?.data?.length
      ? getValidationMessage(error.data.data)
      : _get(error, 'data.message', '');
  } else if (error?.status === 400 && error?.data?.data?.request && error?.data?.data?.response) {
    const errorMessage = _get(error, 'data.data.response.error');

    return humanizeErrorMessage(errorMessage);
  }

  return getAnyErrorMessage(error);
};

const getValidationMessage = details => _map(details, value => value[0]).join('\n');

const technicalErrorMessagePattern = /^request failed with status code \d+$/i;

const sanitizeMessage = message => {
  if (typeof message !== 'string') {
    return '';
  }

  const trimmedMessage = message.trim();

  if (!trimmedMessage || technicalErrorMessagePattern.test(trimmedMessage)) {
    return '';
  }

  return trimmedMessage;
};

const getErrorStatusCode = error => {
  return _get(error, 'status') || _get(error, 'response.status');
};

const getFallbackMessageByStatusCode = statusCode => {
  if (statusCode >= 500) {
    return 'Something went wrong. Please try again later.';
  }

  if (statusCode >= 400) {
    return 'Unable to complete this request. Please check your input and try again.';
  }

  return 'An error has occured';
};

const getAnyErrorMessage = error => {
  const integrationMessage = sanitizeMessage(_get(error, 'data.data.response.message', ''));
  const responseDataMessage = sanitizeMessage(_get(error, 'response.data.message', ''));
  const dataMessage = sanitizeMessage(_get(error, 'data.message', ''));
  const directMessage = sanitizeMessage(_get(error, 'message', ''));

  return (
    integrationMessage ||
    responseDataMessage ||
    dataMessage ||
    directMessage ||
    getFallbackMessageByStatusCode(getErrorStatusCode(error))
  );
};

const mustShowErrorMessage = error => {
  if (!error) {
    return false;
  }

  const ignoreMessages = [
    'jwt.expired',
    'jwt.invalid',
    'token_invalid',
    'token_expired',
    'token_not_provided',
    'external_service_error'
  ];

  const r =
    _get(error, 'data.data.response.message', '') ||
    _get(error, 'data.response.message', '') ||
    _get(error, 'data.error', '') ||
    _get(error, 'error.data.error', '') ||
    _get(error, 'error.data.code', '') ||
    _get(error, 'data.code', '') ||
    '';

  if (_get(error, 'error.message', '') === 'canceled_request') {
    return false;
  } else if (r === 'unauthenticated') {
    return false;
  } else if (ignoreMessages.includes(r)) {
    return false;
  } else {
    return true;
  }
};

const notificationsMiddleware = store => next => action => {
  next(action);
  const { type, payload } = action;

  if ((type.endsWith('ERROR') || type.endsWith('rejected')) && mustShowErrorMessage(payload)) {
    const message = getErrorMessage(payload);
    if (message) {
      store.dispatch(errorHandler({ title: 'Uh oh!', message }));
    }
  }
};
export default notificationsMiddleware;
